<template>
  <template v-if="cart && cart.id">
    <template v-if="lineItems.length > 0">
      <div class="overflow-y-auto flex-1">
        <CartAvailabilityHint />
        <CartProgress class="p-4 lg:px-6" />
        <div class="gap-y-6 p-4 lg:px-6">
          <LineItem v-for="(item, index) in lineItems" :key="item.id" :line-item="item" :index="index" class="mb-6" />
          <CartDeals v-if="appStore.showCartXSellTeasers" />
          <CartSummary />
        </div>
      </div>
      <div class="shrink-0 py-4 px-4 lg:px-6 bg-white border-t border-gray-200">
        <CartCheckoutButton />
      </div>
    </template>
    <CartEmpty v-else />
  </template>
</template>

<script setup>
import LineItem from '@/components/cart/LineItem';
import CartCheckoutButton from '@/components/cart/CartCheckoutButton';
import CartEmpty from '@/components/cart/CartEmpty';
import CartSummary from '@/components/cart/CartSummary';
import CartDeals from '@/components/cart/CartDeals/CartDeals';
import CartProgress from '@/components/cart/CartProgress/index';
import CartAvailabilityHint from '@/components/cart/CartAvailabilityHint';
import { useCartStore } from '@/stores/cart';
import { useCartSettingsStore } from '@/stores/cart-settings';
import { useAppStore } from '@/stores/app';

const cartStore = useCartStore();
const cartSettingsStore = useCartSettingsStore();
const appStore = useAppStore();

const { cart, lineItems } = storeToRefs(cartStore);
const { shippingEntry } = storeToRefs(cartSettingsStore);

const close = () => cartStore.close();
</script>
